import {Openlayers} from './src/Openlayers';
import {createEmpty, extend, isEmpty} from 'ol/extent';
import {Geojson} from './src/Plugins/Layers/Geojson';
import {DrupalJS, LazyLoaderElement, OpenlayersSettings} from "./src/types";
import {Feature} from "ol";
import {Source} from "ol/source";
import VectorSource from "ol/source/Vector";
import {MapConfig} from "./src/MapConfig";

type Once = (name: string, element: Node) => void

/**
 * This wraps all Drupal specific functionality.
 */
(function ($, Drupal: DrupalJS, drupalSettings) {
  Drupal.openlayers = {
    maps: {},
  };


  Drupal.Ajax.prototype.setProgressIndicatorOpenlayers = function () {
    this.progress.element = $(Drupal.theme('ajaxProgressIndicatorOpenlayers'));
    $(this.selector).find('.map-inner').prepend(this.progress.element)
  };

  Drupal.theme.ajaxProgressIndicatorOpenlayers = function () {
    return '<div class="openlayers-ajax-progress"></div>';
  };

  /**
   * Update Map command to update the openlayers map on ajax.
   */
  Drupal.AjaxCommands.prototype.ajaxifyView = function (ajax, response, status) {
    $(response.selector).removeAttr('data-once').addClass('ajax-new-content');
  }

  /**
   * Update Map command to update the openlayers map on ajax.
   */
  Drupal.AjaxCommands.prototype.updateMap = function (ajax, response, status) {

    const data = response.data;

    const map_id = response.map_id;


    const fit_to_extent = response.fit_to_extent ?? true;

    const animate_fit_to_extent = response.animate_fit_to_extent ?? true;

    // The destination url for the ajax call. This will include
    // all necessary query
    const destination = response.destination ?? '';

    const openlayers: Openlayers = Drupal.openlayers.maps[map_id];

    if(openlayers.isAjaxUpdating){
      return;
    }
    openlayers.isAjaxUpdating = true;

    for (const layer_id in data) {
      const geojsonPlugin: Geojson = openlayers.layerPlugins[layer_id];
      geojsonPlugin.updateLayer(data[layer_id]);
    }

    let extent;


    extent = openlayers.getCombinedExtent();

    openlayers.destination = destination;


    if (extent && !isEmpty(extent) && fit_to_extent) {
      openlayers
        .getMap()
        .getView()
        .fit(extent, {
          padding: [100, 100, 100, 100],
          maxZoom: 15,
          duration: animate_fit_to_extent ? 400 : 0,
          callback: (op) => {

              setTimeout(() => {
                openlayers.isAjaxUpdating = false;
              }, 1000);

          }
        })
    } else{
      openlayers.isAjaxUpdating = false;
    }
  };

  // This is a hacky way to reset the _on_moovend key. This
  // key is used to indicated how the map + list should be updated
  // but it is persistent in the ajax instances.
  Drupal.behaviors.openlayersResetAjax = {
    attach: (context: Element, settings: any) => {
      Object.entries(Drupal.ajax.instances).forEach(([key, instance])=> {
        if(instance?.submit?._on_moovend !== undefined){
          Drupal.ajax.instances[key].submit._on_moovend = '0';
          delete Drupal.ajax.instances[key].submit._exposed_input;
          if(Drupal.ajax.instances[key].progress) {
            Drupal.ajax.instances[key].progress.type = 'openlayers';
          }
        }
      })
      Object.entries(Drupal.views.instances).forEach(([key, instance]) => {
        const settings = instance?.settings;
        if(settings) {
          settings._on_moovend = '0';
          delete settings._exposed_input;
          Drupal.views.instances[key].settings = settings;
          if (Drupal.views.instances[key].progress) {
            Drupal.views.instances[key].progress.type = 'openlayers';
          }
        }
      })
    }
  }
  /**
   * General openlayers behavior.
   */
  Drupal.behaviors.openlayers = {
    attach: (context: Element, settings: any) => {



      once('bind-hover-click', '.openlayers-views-list-row', context).forEach((element) => {
        element.classList.remove('is-active');
        element.addEventListener('click', (event: Event) => {

          const entity_id = element.getAttribute('data-entity-id');
          const map_id = element.getAttribute('data-map-id');
          const openlayers: Openlayers = Drupal.openlayers.maps[map_id];
          if(openlayers.isAjaxUpdating){
            return;
          }
          openlayers.isAjaxUpdating = true;
          let extent = createEmpty();
          Object.values(openlayers.sources).forEach((source: Source) => {
            if (!(source instanceof VectorSource)) {
              return;
            }
            source.forEachFeature((feature: Feature) => {
              const property = openlayers.getHoverProperty(feature);
              if (!property) {
                return;
              }
              if (feature.get('_list_entity_id') == entity_id) {
                extent = extend(feature.getGeometry().getExtent(), extent);
              }
            })
          })

          if(!isEmpty(extent)) {
            openlayers.getMap()
              .getView()
              .fit(extent, {
                padding: [openlayers.getMap().getSize()[1] / 4, openlayers.getMap().getSize()[0] / 4, openlayers.getMap().getSize()[1] / 4, openlayers.getMap().getSize()[0] / 4],
                duration: 400,
                callback: () => {

                  setTimeout(() => {
                    openlayers.isAjaxUpdating = false;
                  }, 500);

                }
              })
          }
        })
        element.addEventListener('mouseenter', (event: Event) => {
          const entity_id = element.getAttribute('data-entity-id');
          const map_id = element.getAttribute('data-map-id');
          const openlayers: Openlayers = Drupal.openlayers.maps[map_id];

          if (openlayers.filter) {
            openlayers.filter.setActive(true);
          }

          // @ts-ignore
          Object.values(openlayers.sources).forEach((source: Source) => {
            if (!(source instanceof VectorSource)) {
              return;
            }
            source.forEachFeature((feature: Feature) => {
              const property = openlayers.getHoverProperty(feature);
              if (!property) {
                return;
              }
              feature.set(property, false);
              if (feature.get('_list_entity_id') == entity_id) {
                feature.set(property, true);
              }
            })
          })
        })
        element.addEventListener('mouseleave', (event: Event) => {

          const map_id = event?.target?.getAttribute('data-map-id');
          const openlayers: Openlayers = Drupal.openlayers.maps[map_id];

          if (openlayers.filter) {
            openlayers.filter.setActive(false);
          }
          // @ts-ignore
          Object.values(openlayers.sources).forEach((source: Source) => {
            if (!(source instanceof VectorSource)) {
              return;
            }
            source.forEachFeature((feature: Feature) => {
              const property = openlayers.getHoverProperty(feature);
              if (!property) {
                return;
              }
              feature.unset(property);
            })
          })
        })
      })

      if(context?.classList?.contains('openlayers-map')) {


        Object.values(Drupal?.openlayers?.maps).forEach((openlayers: Openlayers) => {

          openlayers.getMap().on('click', (e: { pixel: any; }) => {

            if (openlayers.getMap().get('drawing')) {
              return;
            }

            // Use document and not context because the views list rows are outside the context.
            document.querySelectorAll('.openlayers-views-list-row').forEach((element) => {
              element.classList.remove('is-clicked');
            })
            const featuresAtPixel = openlayers.getMap().getFeaturesAtPixel(e.pixel);
            featuresAtPixel.forEach((featureAtPixel: Feature) => {
              if (featureAtPixel.get('_list_entity_id')) {
                document.querySelector('[data-entity-id="' + featureAtPixel.get('_list_entity_id') + '"]')?.classList.add('is-clicked')
                let bounding = document.querySelector('[data-entity-id="' + featureAtPixel.get('_list_entity_id') + '"]')?.getBoundingClientRect();
                if (bounding) {
                  if (bounding.top >= 0 && bounding.left >= 0 && bounding.right <= window.innerWidth && bounding.bottom <= window.innerHeight) {

                  } else {
                    document.querySelector('[data-entity-id="' + featureAtPixel.get('_list_entity_id') + '"]')?.scrollIntoView({
                      block: "end",
                      inline: "nearest",
                      behavior: "smooth"
                    });
                  }
                }
              }
            })
          })
          openlayers.getMap().on('pointermove', (e: { pixel: any; }) => {
            if (openlayers.getMap().get('drawing')) {
              return;
            }
            document.querySelectorAll('.openlayers-views-list-row').forEach((element) => {
              element.classList.remove('is-hovered');
            })
            const featuresAtPixel = openlayers.getMap().getFeaturesAtPixel(e.pixel);
            featuresAtPixel.forEach((featureAtPixel: Feature) => {
              if (featureAtPixel.get('_list_entity_id')) {
                document.querySelector('[data-entity-id="' + featureAtPixel.get('_list_entity_id') + '"]')?.classList.add('is-hovered')
              }
            })
          })
        })
      }


      // Update map size and zoom to extents when the map becomes visible in the browser.
      // This solution should work for every type of interaction such as modals,
      // field groups, tabs and states.
      const updateMapSize = (target: Element) => {
        const io = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              Drupal.openlayers.maps[target.id].getMap().updateSize();
              let extent = Drupal.openlayers.maps[target.id].getCombinedExtent();
              if (!isEmpty(extent)) {
                Drupal.openlayers.maps[target.id]
                  .getMap()
                  .getView()
                  .fit(extent, {
                    padding: [100, 100, 100, 100],
                    maxZoom: 15,
                  });
              }
              observer.disconnect();
            }
          })
        }, {threshold: [0.7]});

        io.observe(target);
      }

      const maps = once('openlayers-map-init', '.openlayers-map', context).forEach((element: Element) => {


        const map_id = element.getAttribute('id');
        if (!map_id) {
          throw new Error('The map element should have an ID attribute');
        }
        const mapConfig = settings?.openlayers?.maps[map_id]?.mapConfig;
        const tooltipElement = context.querySelector('#' + map_id?.replaceAll('_', '-') + '__tooltip');
        const lazyLoadingProgressElement = context.querySelector('.openlayers-lazy-loading-progress');

        let featureSelectContainerElement = null;
        if (mapConfig.view.feature_select_container ?? false) {
          featureSelectContainerElement = context.querySelector('.' + map_id.replace('js-view-openlayers', 'js-view-dom-id') + ' .feature-select-container');
        }
        const data = settings.openlayers.maps[map_id]?.data;
        const lazyData = settings.openlayers.maps[map_id]?.lazy_data;

        // Add map data to the openlayers global object.
        let openlayers = new Openlayers(
          element,
          map_id,
          mapConfig,
          data,
          lazyData,
          tooltipElement,
          lazyLoadingProgressElement,
          featureSelectContainerElement,
        );
        Drupal.openlayers.maps[map_id] = openlayers;

        updateMapSize(element);

        Drupal.attachBehaviors(openlayers.element);
      });
    },
  };

  /**
   * Adds theming for the openlayers lazy progress bar.
   */
  Drupal.theme.openlayersLazyProgress = (lazy_loader_element: LazyLoaderElement, loaded_items: number) => {
    const total = lazy_loader_element.dataset.total;
    const progress = +lazy_loader_element.dataset.progress + +loaded_items;
    lazy_loader_element.dataset.progress = progress;
    const percentage = (progress / total) * 100;
    const progress_percentage = percentage < 100 ? percentage : 100;
    lazy_loader_element.querySelector('.progress').style.width = progress_percentage + '%';
    if (progress_percentage == 100) {
      lazy_loader_element.classList.add('complete');
    }
  };


})(jQuery, Drupal, drupalSettings);
